<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12307_17353)">
<path d="M9.99935 18.3307C14.6017 18.3307 18.3327 14.5998 18.3327 9.9974C18.3327 5.39502 14.6017 1.66406 9.99935 1.66406C5.39698 1.66406 1.66602 5.39502 1.66602 9.9974C1.66602 14.5998 5.39698 18.3307 9.99935 18.3307Z" stroke="white" stroke-opacity="0.4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66602 11.6641C6.66602 11.6641 7.91602 13.3307 9.99935 13.3307C12.0827 13.3307 13.3327 11.6641 13.3327 11.6641" stroke="white" stroke-opacity="0.4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.5 7.5H7.50833" stroke="white" stroke-opacity="0.4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.5 7.5H12.5083" stroke="white" stroke-opacity="0.4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_12307_17353">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
